import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@nerdwallet/currency';

import cityChange from '../../../../lib/actions/cityChange';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/home-affordability-calculator-selectors';
import {
  RentVsBuyInput,
  debouncedTrackOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import LocationAutoComplete from '../../../location-autocomplete/location-autocomplete';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

const LocationInput: React.FC<RentVsBuyInput> = ({
  manualInputs,
  inputs,
  dispatch,
  label,
  analytics,
  className,
}) => {
  const segmentAbstract = useAnalytics();
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (value) => {
    const { city, zip } = value;
    const trackingValue = `${city}${zip ? ` (${zip})` : ''}`;

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'user_type_input',
        entityName: 'city',
        field_value: city,
        field: 'City',
      },
      segmentAbstract
    );

    debouncedTrackOnChange({
      bedrock,
      validation: { valid: true },
      value: trackingValue,
    });

    dispatch(cityChange(value, 'purchaseAddress'));
  };

  return (
    <Box className={className}>
      <LocationAutoComplete
        data={manualInputs}
        enableTracking={false}
        label={label}
        key="hac-location-autocomplete"
        onChange={onInputChange}
        placeholder={`${inputs.purchaseAddress.city}, ${inputs.purchaseAddress.state}`}
        trackingFormName="onboarding"
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LocationInput);
